import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { Posting } from 'app/library/posting/models/posting.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { GeneralAnalyticsService } from '../../../../services/general-analytics.service';

@Component({
    selector: 'app-posting-details-dialog',
    templateUrl: './posting-details-dialog.component.html',
    styleUrls: ['./posting-details-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PostingDetailsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    posting: Posting;

    @Input()
    widget: { id: string; name: string };

    constructor(
        public dialogRef: MatDialogRef<PostingDetailsDialogComponent>,
        public tenantDataService: TenantDataService,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        private _router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.sendPostingViewEvent('posting_clicked');
    }

    openPostingUrl() {
        const posting = this.posting;
        this.sendPostingViewEvent('posting_link_followed');

        // If the url starts with the same domain as the custom domain (whole one, not just base domain) then open internally
        if (posting.url.includes(window.location.host)) {
            this.dialogRef.close();
            window.open(`${posting.url}`, '_self');
        } else {
            const currentPostUrl = posting.url;
            window.open(currentPostUrl, '_blank');
        }
    }

    async sendPostingViewEvent(eventName: string) {
        if (this._router.url === '/grow/search') {
            this._locationBasedAnalyticsService.createPostingEvent(
                eventName,
                this.posting.id,
                this.posting.postingType.id,
                this.posting.translation.title,
                null,
                this.widget.id,
                this.widget.name
            );
        }
    }
}
